import { icons } from '../../utils/icons';
import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { IconData } from '../../models/icon-data.model';
import { NgClass, NgForOf, NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    NgForOf,
    NgIf,
  ],
})
export class IconComponent {
  @Input() set name(value: string) {
    if (icons[value]) {
      this.icon = icons[value];
    } else {
      throw new Error(`Icon ${value} not found`);
    }
  }
  @Input() size = 24;
  @Input() height: number;
  @Input() width: number;
  @HostBinding('style.color') @Input() color: string;
  @Input() viewBox;

  public icon: IconData;
}
